import { ymdToDate } from '@kit/utils/Formats'

/**
 * @param {Date or yyyy-mm-dd String} start. required 
 * @param {Date or yyyy-mm-dd String} end. required 
 * @param {Null or Date or yyyy-mm-dd String} _test. optional. Will default to today
 * @param {Null or Int: XSTART, XEND, XBOTH} _exc. optional. Will default to falsy
 *   If XSTART it will exclude the starting date 
 *   If XEND it will exclude the ending date 
 *   If XBOTH it will exclude both starting and ending dates 
 *   Otherwise, it will include both starting and ending dates
 *
 * @returns { Boolean } true if test is between with boundary conditions, false if otherwise
 */

export const XSTART = 1 
export const XEND = 2 
export const XBOTH = 3

export function testDateInRange(start, end, _test, _exc) {
	if (!start || !end) return false;

  let test = _test || new Date()

  const startDate = start instanceof Date ? start : ymdToDate(start)
  const endDate = end instanceof Date ? end : ymdToDate(end)
  const testDate = test instanceof Date ? test : ymdToDate(test)

  if(_exc == XSTART) {
    return testDate > startDate && testDate <= endDate
  } else 
  if(_exc == XEND) {
    return testDate >= startDate && testDate < endDate
  } else 
  if(_exc == XBOTH) {
    return testDate > startDate && testDate < endDate
  } else {
    return testDate >= startDate && testDate <= endDate
  }

}


